module.exports = __webpack_public_path__ + "images/a9523f8007b01ea89eb573e7e79bc67e.png";